import { Getters } from "vuex-smart-module";
import MapState from "./state";

export default class MapGetters extends Getters<MapState> {
  get measurementActivated() {
    return this.state.measurementActivated;
  }
  get selectedFeatures() {
    return this.state.selectedFeatures;
  }
  get selectedTargets() {
    return this.state.selectedTargets;
  }
  get mapCenter() {
    return this.state.mapCenter;
  }
  get mapBounds() {
    return this.state.bbox;
  }
  get mapZoom() {
    return this.state.mapZoom;
  }
  get baseLayer() {
    return this.state.baseLayer;
  }
  get targetsTagsZoom() {
    return this.state.targetsTagsZoomLevel;
  }
  get platformsTagsZoom() {
    return this.state.platformsTagsZoomLevel;
  }
  get targetTagsEnabledByZoom(): boolean {
    return this.state.mapZoom >= this.state.targetsTagsZoomLevel;
  }

  get platformsTagsEnabledByZoom(): boolean {
    return this.state.mapZoom >= this.state.platformsTagsZoomLevel;
  }
  get measurementUnits() {
    return this.state.measurementNauticalUnits;
  }
  get measurementPoints() {
    return this.state.measurementPoints;
  }
  get totalDistance() {
    return this.state.totalDistance;
  }
}
